// extracted by mini-css-extract-plugin
export default {"employee-container":"JobGrade_employee-container__3fUsg"};